import type { ReactNode } from 'react';

// 页面统一容器:全宽布局,统一内边距与子元素间距
export function PageContainer({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex w-full flex-col gap-4 px-5 pt-4 pb-10 ${className}`}>
      {children}
    </div>
  );
}
